import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Reveal from "@/components/Reveal";

/**
 * Short narrative section placed directly below the hero.
 * Reframes St. Kitts from "sun, sand & sea" to a living botanical heritage.
 */
const BeyondSunSandSea = () => {
  return (
    <section className="relative bg-[hsl(40_45%_96%)] py-20 md:py-28 border-b border-accent/10">
      <div className="container mx-auto px-6 max-w-3xl text-center">
        <Reveal>
          <p className="font-sans text-[11px] tracking-[0.42em] uppercase text-accent mb-6">
            Beyond Sun, Sand &amp; Sea
          </p>
          <h2 className="font-serif text-3xl md:text-[2.6rem] text-foreground leading-tight mb-8">
            There is another St. Kitts.
          </h2>
          <div aria-hidden className="mx-auto mb-8 h-px w-12 bg-accent/60" />
          <p className="font-serif italic text-foreground/75 text-lg md:text-xl leading-relaxed mb-6">
            A volcanic island of rainforest, coastal plants, hidden trails,
            traditional foods, survival stories, and botanical knowledge passed
            from generation to generation.
          </p>
          <p className="font-sans text-base md:text-lg text-foreground/70 leading-[1.8] mb-5">
            Sugar Town Organics was born from this living landscape. Our
            products, foods, experiences, and wellness rituals are rooted in the
            forests, farms, gardens, ghauts, and cultural memory of St.&nbsp;Kitts —
            preserving what our people knew, used, made, cooked, healed with, and
            carried forward.
          </p>
          <p className="font-sans text-base md:text-lg text-foreground/80 leading-[1.8] mb-10">
            This is not just nature-inspired wellness. This is{" "}
            <span className="font-semibold text-foreground">
              Kittitian botanical heritage, reimagined for today.
            </span>
          </p>
          <Link
            to="/forest-heritage"
            className="group inline-flex items-center gap-2 bg-primary text-primary-foreground px-8 py-4 rounded-sm font-sans font-semibold text-[11px] uppercase tracking-[0.28em] hover:opacity-90 transition-opacity"
          >
            Explore the Forest Heritage
            <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
          </Link>
        </Reveal>
      </div>
    </section>
  );
};

export default BeyondSunSandSea;
